export enum UserRole {
  CASHIER = 'cashier',
  ADMIN = 'admin',
  MANAGER = 'manager'
}

export interface User {
  id: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  branchId: string;
  isActive: boolean;
  lastLoginAt?: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface LoginCredentials {
  username: string;
  password: string;
  branchId: string;
}

export interface AuthToken {
  accessToken: string;
  refreshToken: string;
  expiresAt: Date;
}

export interface UserSession {
  user: User;
  token: AuthToken;
  branchId: string;
  branchName?: string;
  loginTime: Date;
  /** Offline Electron session — tokens may be stale until reconnect refresh */
  sessionMode?: 'online' | 'offline';
} 